<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="数据采集发布" name="1">
      <SjcjAdd :updataID='updataID'></SjcjAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 数据采集修改
 */
import SjcjAdd from '../../../../static/form/SjcjAdd.vue'
export default {
  components: {
    SjcjAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/Sjcjgl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/SjcjUpdate.vue